export default "__VITE_ASSET__CgINkkNu__"